'use client';

import { SEARCH_CONSTANTS } from '@/constants';
import { Button } from '@tallinn-arvudes/ui/tallinn-design/Button';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';

const { PAGE_PARAM } = SEARCH_CONSTANTS;

export const LoadMore = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const currentPage = Number(searchParams.get(PAGE_PARAM)) || 1;

  const createPageURL = (pageNumber: number | string) => {
    const params = new URLSearchParams(searchParams);
    params.set(PAGE_PARAM, pageNumber.toString());
    return `${pathname}?${params.toString()}`;
  };

  return (
    <Link
      prefetch
      scroll={false}
      replace
      href={createPageURL(currentPage + 1)}
      passHref
      legacyBehavior
    >
      <Button variant="secondary" className="mt-8">
        Näita rohkem
      </Button>
    </Link>
  );
};
